<!-- Modale semplificata: solo contenuto essenziale senza card/bordi -->

<h2 mat-dialog-title style="margin: 0; padding: 16px 24px; font-size: 18px; font-weight: 500; border-bottom: 1px solid #e0e0e0;">
  Descrizione articolo: {{ data.code }}
</h2>

<mat-dialog-content style="padding: 24px; min-height: 100px; max-height: 400px; overflow-y: auto;">
  <p style="margin: 0; line-height: 1.6; color: #333; white-space: pre-wrap;">{{ data.description }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end" style="padding: 8px 16px; border-top: 1px solid #e0e0e0;">
  <button mat-button (click)="onClose()">
    {{ 'close' | translate }}
  </button>
</mat-dialog-actions>
